export const AppMap = {
  思睿教育集团: {
    appId: 'cli_a0280c18ac38900c',
  },
};
